import { useAuth } from '../context/AuthContext';

/** @param {string|string[]} code */
export function useCan(code) {
  const { can } = useAuth();
  if (Array.isArray(code)) {
    return code.every((c) => can(c));
  }
  return can(code);
}
